export default __webpack_public_path__ + "/370743__podsburgh__winner-metal-bell-ringing-remix.mp3";